import { MediaQuery } from '@grandvisionhq/common';
import { getContentByRef } from './get-content-by-ref.js';

function getPlpPromotionSize(pageModel, breakpoint, refPrefix) {
    var ref, ref1;
    if (!pageModel) {
        return {};
    }
    const catalogComponent = Object.values(pageModel.page).find(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (value)=>value.label === 'Product catalog v2'
    );
    if (!catalogComponent) {
        return {};
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const ref2 = (ref = catalogComponent.models) === null || ref === void 0 ? void 0 : (ref1 = ref.document) === null || ref1 === void 0 ? void 0 : ref1.$ref;
    const content = getContentByRef(ref2, pageModel, refPrefix);
    var ref3;
    const { smallPromotion , bigPromotion  } = (ref3 = content === null || content === void 0 ? void 0 : content.data) !== null && ref3 !== void 0 ? ref3 : {};
    const isSmallScreen = breakpoint === MediaQuery.BreakpointName.PHONE;
    const smallPromoSize = smallPromotion ? isSmallScreen ? 2 : 1 : 0;
    const bigPromoSize = bigPromotion ? 2 : 0;
    return {
        plpPromotionSize: smallPromoSize + bigPromoSize
    };
}

export { getPlpPromotionSize };
//# sourceMappingURL=get-plp-promotion-size.js.map
